import '@babel/polyfill';
import React from 'react';
import { hydrate } from 'react-dom';
import { Provider } from 'react-redux';
import {
  ConnectedRouter,
} from 'react-router-redux';
import 'nodelist-foreach-polyfill'; // IE11 support, needed for 'react-slider' carousels
import 'isomorphic-fetch';
import hyperform from 'hyperform';
import { CookiesProvider } from 'react-cookie';

import Amplify from 'aws-amplify';

import App from './App';
import AppRouter from './appRouter';
import './globalStyle';
import store, { history } from './store';
import storage from './auth/storage';

window.hyperform = hyperform;
window.store = store;

Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
    region: 'us-west-2',
    identityPoolRegion: 'us-west-2',
    userPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    storage,
  },
});

hydrate(
  (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <CookiesProvider>
          <App>
            <AppRouter />
          </App>
        </CookiesProvider>
      </ConnectedRouter>
    </Provider>
  ),
  document.getElementById('root'),
);
